<script setup lang="ts">
import Header from "./Header.vue";
import Footer from "./Footer.vue";
import XLayout from "./AuthLayout/XLayout.vue";
</script>

<template>
  <div class="relative flex flex-col min-h-screen gap-4 justify-between bg-[#0a0e1a] transition-colors duration-500">
    <!-- Animated background elements -->
    <div class="fixed inset-0 pointer-events-none overflow-hidden opacity-60">
      <!-- Animated circles -->
      <div class="circle-glow circle-glow-1"></div>
      <div class="circle-glow circle-glow-2"></div>
      <div class="circle-glow circle-glow-3"></div>
      <div class="circle-glow circle-glow-4"></div>
      <div class="circle-glow circle-glow-5"></div>
      <div class="circle-glow circle-glow-6"></div>

      <!-- Floating wave shapes -->
      <svg class="wave-shape wave-1" viewBox="0 0 1200 300" xmlns="http://www.w3.org/2000/svg">
        <path d="M0,100 Q300,50 600,100 T1200,100" stroke="rgba(99, 102, 241, 0.15)" stroke-width="2" fill="none"/>
      </svg>
      <svg class="wave-shape wave-2" viewBox="0 0 1200 300" xmlns="http://www.w3.org/2000/svg">
        <path d="M0,150 Q300,100 600,150 T1200,150" stroke="rgba(147, 51, 234, 0.15)" stroke-width="2" fill="none"/>
      </svg>
      <svg class="wave-shape wave-3" viewBox="0 0 1200 300" xmlns="http://www.w3.org/2000/svg">
        <path d="M0,200 Q300,150 600,200 T1200,200" stroke="rgba(59, 130, 246, 0.15)" stroke-width="2" fill="none"/>
      </svg>

      <!-- Geometric floating shapes - squares and circles -->
      <div class="floating-shape shape-1"></div>
      <div class="floating-shape shape-2"></div>
      <div class="floating-shape shape-3"></div>
      <div class="floating-shape shape-4"></div>
      <div class="floating-shape shape-5"></div>
      <div class="floating-shape shape-6"></div>
      <div class="floating-shape shape-7"></div>
      <div class="floating-shape shape-8"></div>
    </div>

    <div class="relative z-10">
      <Header />

      <main class="xl:w-[1200px] mx-2 sm:mx-4 md:mx-6 xl:mx-auto">
        <XLayout v-if="$route.meta.isXLayout">
          <slot />
        </XLayout>
        <slot v-else />
      </main>
    </div>

    <Footer class="relative z-10" />
  </div>
</template>
